import BaseApi from './base.api';

export interface CreatePatientRequest {
  egn?: string;
  rzok: string;
  zdrRajon: string;
  givenName: string;
  surName: string;
  familyName: string;
  address: string;
  isHealthInsurance: boolean;
  dateOfBirth?: string;
  yearOfBirth?: number;
  gender: 'MALE' | 'FEMALE';
  email?: string;
  phone?: string;
  medicalHistory?: string;
}

export interface UpdatePatientRequest extends Partial<CreatePatientRequest> {
  active?: boolean;
}

export interface PatientResponse {
  id: number;
  egn?: string;
  rzok: string;
  zdrRajon: string;
  givenName: string;
  surName: string;
  familyName: string;
  fullName: string;
  address: string;
  isHealthInsurance: boolean;
  dateOfBirth?: string;
  yearOfBirth?: number;
  gender: 'MALE' | 'FEMALE';
  email?: string;
  phone?: string;
  medicalHistory?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PatientPageResponse {
  content: PatientResponse[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
}

class PatientApi extends BaseApi {
  async createPatient(patient: CreatePatientRequest): Promise<PatientResponse> {
    return this.post('/patients', patient);
  }

  async updatePatient(id: number, patient: UpdatePatientRequest): Promise<PatientResponse> {
    return this.put(`/patients/${id}`, patient);
  }

  async getAllPatients(): Promise<PatientResponse[]> {
    return this.get('/patients');
  }

  async getPatientsPaginated(page: number = 0, size: number = 20, sortBy: string = 'createdAt', sortDir: string = 'desc'): Promise<PatientPageResponse> {
    return this.get('/patients/paginated', {
      params: { page, size, sortBy, sortDir }
    });
  }

  async getPatientById(id: number): Promise<PatientResponse> {
    return this.get(`/patients/${id}`);
  }

  async getPatientByEgn(egn: string): Promise<PatientResponse> {
    return this.get(`/patients/egn/${egn}`);
  }

  async deletePatient(id: number): Promise<void> {
    return this.delete(`/patients/${id}`);
  }

  async searchPatients(query: string): Promise<PatientResponse[]> {
    return this.get(`/patients/search?q=${encodeURIComponent(query)}`);
  }

  async deleteMyAccount(): Promise<void> {
    return this.delete('/patients/me');
  }
}

export default new PatientApi();